"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MANAGE_ORDER = void 0;
var MANAGE_ORDER = {
  BUTTON__APPROVE: 'manageOrderMenu-button-approveOrder',
  BUTTON__CANCEL: 'manageOrderMenu-button-cancelOrder',
  BUTTON__COMPLETE: 'manageOrderMenu-button-completeOrder',
  BUTTON__DECLINE: 'manageOrderMenu-button-declineOrder',
  BUTTON__EDIT: 'manageOrderMenu-button-edit',
  BUTTON__EDIT_INTERVAL: 'manageOrderMenu-button-editInterval',
  BUTTON__REORDER: 'manageOrderMenu-button-reorder',
  BUTTON__RESOLVE: 'manageOrderMenu-button-resolveOrder',
  BUTTON__SCHEDULE_FOR_DELIVERY: 'manageOrderMenu-button-scheduleForDelivery',
  BUTTON__STOP_ORDER: 'manageOrderMenu-button-stopOrder',
  BUTTON__ADD_NEW_CREDIT_NOTE: 'manageOrderMenu-button-addNewCreditNote'
};
exports.MANAGE_ORDER = MANAGE_ORDER;